export default "__VITE_ASSET__BYz8jUbP__"